export type PullCiState = "success" | "failure" | "pending" | "neutral" | "unavailable";

/** GitHub actor types that represent people rather than apps or automation. */
export function isHumanGitHubActor(authorType: string | undefined): boolean {
  return authorType === "User" || authorType === "EnterpriseUserAccount";
}

/**
 * Small, list-safe projection of the PR context that deserves attention before
 * somebody opens the full review. Detailed checks and threads stay on the PR.
 */
export interface PullAttentionSummary {
  ci: {
    state: PullCiState;
    total: number;
    failed: number;
    pending: number;
  } | null;
  conversation: {
    issueComments: number;
    reviewThreads: number;
    unresolvedThreads: number;
    latest: {
      author: string;
      authorType?: string;
      body: string;
      createdAt: string;
      url: string;
    } | null;
  } | null;
}
